export default __webpack_public_path__ + "static/lchapman-5232bb80e754c0c9996da0337b1f0ccf.png";